import React from 'react';
import { ContactCaptureAnalyticsView } from '../components';
export const ContactCaptureAnalyticsPage = () => <ContactCaptureAnalyticsView />;
